<template>
  <div class="comments" >
    <van-row class="my_blind_date">
      <van-col span="22" offset="1" v-if="is_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('onLoad.finished_text')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="my_blind_date_type">
              <van-col span="10" class="my_blind_date_avatar">
                <van-image
                  round
                  :src="t.first_avatar"
                  @click="user_Jump(t.first_uid)"
                />
                <van-image
                  round
                  :src="t.avatar"
                  @click="user_Jump(t.uid)"
                />
                <div class="my_blind_date_type_hname" v-if="t.is_host">{{ t.first_name | get_type }}</div>
              </van-col>
              <van-col span="9" class="my_blind_date_center">
                <van-col span="24" class="my_blind_date_center_name"> {{ t.name }} </van-col>
                <van-col span="24" class="my_blind_date_center_age"> {{ t.sex | get_sex($t('user.sex1'),$t('user.sex2')) }} <span v-if="t.province"> | {{ t.province }}</span> </van-col>
              </van-col>
              <van-col span="5" class="my_blind_date_right">
                {{ t.addtime | get_time }}
              </van-col>

            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" v-else>
        <van-col span="24" class="no-data">
          <img src="../assets/img/zwsl.png"/>
        </van-col>
        <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>
  //请求接口组件
  import '@/assets/css/style.css'
  import Toast from "vant/lib/toast"
  import { judgeIosAndroid } from '@/assets/js/models.js'
  import axios from 'axios'
  export default {
    filters: {
      get_sex (sex,t1,t2) {
        return sex === 1 ? t1 : t2
      },
      get_type (str) {
        return str.substr(0,2);
      },
      get_time (time) {
        let d = new Date(parseInt(time * 1000))
        return (d.getMonth() + 1 > 9 ? d.getMonth() + 1 : '0' + (d.getMonth() + 1)) + '-' + (d.getDate() > 9 ? d.getDate() : '0' + d.getDate());
      }
    },
    data(){
      return {
        finished: false,
        loading: false,
        is_list: true,
        list: [],
        page: 1
      }
    },
    created: function() {
      this.list = []
      this.convert()
      document.title = this.$t('title.blind_date_record')
    },
    methods: {
      onLoad() {
        this.convert()
      },
      convert: function() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        const touid = this.$route.query.touid
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/user_api/get_blind_date_log",{ params:{ uid:uid,token:token,page: this.page, touid:touid }}).then(res => {
          console.log(res.data);
          if (res.data.code == 1) {
            if (res.data.data.length > 0) {
              for (let i = 0; i < res.data.data.length; i++) {
                this.list.push(res.data.data[i]);
              }
              this.is_list = true
              this.page = this.page + 1
              this.loading = false
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.loading = true
              this.finished =true
            }
          } else {
            if(this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            if(this.page !== 1) {
              Toast(this.$t('onLoad.No_data_available'))
            }
          }
        })
      },
      user_Jump (uid) {
        //  拦截
        const isIos = judgeIosAndroid();
        if (isIos == true) {
          // ios传值方法postMessage（val）传值方式
          window.webkit.messageHandlers.homepage.postMessage(uid)
        } else {
          // ios传值方法goSubmitted（val）传值方式
          window.AndroidJs.homepage(uid)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/blind_date_record.vue